// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { listStyles } from "@tps/Overrides/Widgets/Brand/BrandList";
import { color, xScreen } from "@tps/XDL/Utilities";
import { css } from "styled-components";

listStyles.brandLetter = {
    variant: "h3",
    weight: "bold",
    css: css`
        text-transform: uppercase;
        margin-bottom: 0;
    `,
};

listStyles.backToTopLink = {
    typographyProps: {
        size: 14,
        weight: "bold",
        lineHeight: "22px",
        css: css`
            letter-spacing: 0;
            display: flex;
            align-items: center;
        `,
    },
};

listStyles.brandLink = {
    typographyProps: {
        size: 16,
        lineHeight: "22px",
        weight: "bold",
        ellipsis: true,
        css: css`
            white-space: normal;
        `,
    },
    css: css`
        align-self: start;
    `,
};

listStyles.brandSections = {
    css: css`
        display: flex;
        flex-direction: column;
        &:not(:last-child) {
            margin-bottom: 52px;
        }
    `,
};

listStyles.brandAlphabetSections = {
    css: css`
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 16px;
        border-bottom: 1px solid ${color("common.border")};
        padding-bottom: 12px;
    `,
};

listStyles.allBrandsTitle = {
    variant: "h2",
    css: css`
        margin-bottom: 0;
    `,
};

listStyles.clearFiltersButton = {
    variant: "secondary",
};

listStyles.titleWrapper = {
    css: css`
        display: flex;
        justify-content: space-between;
        align-items: flex-start;
        flex-wrap: wrap;
        gap: 10px;
        margin-bottom: 24px;
    `,
};

listStyles.brandItem = {
    css: css`
        padding: 0;
        display: flex;
        width: calc(100% / 4);
        ${xScreen("lte", "md")} {
            width: 50%;
            &:nth-child(even) {
                padding-left: 10px;
            }
            &:nth-child(odd) {
                padding-right: 10px;
            }
        }
        ${xScreen("lte", 767)} {
            width: 100%;
            &&& {
                padding: 0;
            }
        }

    `,
};

listStyles.brandItems = {
    css: css`
        display: flex;
        flex-wrap: wrap;
        row-gap: 16px;
    `,
};

listStyles.searchKeyTitleWrapper = {
    css: css`
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        align-items: flex-start;
        flex-wrap: wrap;
        gap: 10px;
    `,
};
